const DEFAULT = {
  blocked: [],
};

const getConfig = () => {
  try {
    const config = JSON.parse(localStorage.getItem('config'));
    if (config) return config;
  } catch (error) {
    console.error(error);
  }

  return DEFAULT;
};

const setConfig = (config) => {
  localStorage.setItem('config', JSON.stringify(config));
};

export const toggleUserBlocked = (username) => {
  const config = getConfig();

  if (config.blocked.indexOf(username) === -1) config.blocked.push(username);
  else config.blocked.splice(config.blocked.indexOf(username), 1);

  setConfig(config);
};

export const blockedUsers = () => {
  return getConfig().blocked;
}
